<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="detailsContent">
      <el-form>
        <div class="version_list">
          <div
            class="version_btn"
            @click="setVersionInfo(0)"
            :class="versionIndex === 0 && 'checked'"
          >
            IOS版本配置
          </div>
          <div
            class="version_btn"
            @click="setVersionInfo(1)"
            :class="versionIndex === 1 && 'checked'"
          >
            Android版本配置
          </div>
          <div
            class="version_btn"
            @click="setVersionInfo(2)"
            :class="versionIndex === 2 && 'checked'"
          >
            JJLin Toolbox版本配置
          </div>
        </div>
        <el-form-item label="當前版本 ：">
          <input
            maxlength="100"
            class="el-input__inner"
            type="text"
            v-model="versionList.version"
            v-if="changeType"
          />
          <div v-else-if="versionList.version">{{ versionList.version }}</div>
          <div v-else>-</div>
        </el-form-item>
        <el-form-item label="更新鏈接 ：">
          <input
            class="el-input__inner"
            type="text"
            v-model="versionList.updateUrl"
            v-if="changeType"
          />
          <div v-else-if="versionList.updateUrl">
            {{ versionList.updateUrl }}
          </div>
          <div v-else>-</div>
        </el-form-item>
        <el-form-item label="強制更新 ：">
          <el-switch
            active-color="#6C3DEA"
            v-model="forcedUpdate"
            :disabled="!changeType"
          />
        </el-form-item>
        <el-form-item label="更新内容 ：">
          <template v-if="changeType">
            <div
              v-for="(item, index) in versionList.renewContent"
              :key="index"
              class="update_detail_list"
            >
              <input
                class="el-input__inner"
                type="text"
                v-model="versionList.renewContent[index]"
              />
              <span
                class="delete_btn"
                v-on:click="editRenewContent('cut', index)"
                >删除</span
              >
            </div>
          </template>
          <template v-else-if="versionList.renewContent.length">
            <div v-for="(item, index) in versionList.renewContent" :key="index">
              {{ item }}
            </div>
          </template>
          <div v-else>-</div>
          <div
            class="add_btn"
            v-on:click="editRenewContent('add')"
            v-if="changeType && this.versionList.renewContent.length < 5"
          >
            添加
          </div>
        </el-form-item>
      </el-form>
      <div class="bottomBtn">
        <div class="btn" v-if="!changeType" @click="changeType = true">
          编辑
        </div>
        <div v-else class="bottomBtnGroup">
          <div class="btn borderBtn" @click="cancelConfirm()">取消</div>
          <div class="btn" @click="editConfirm()">確認修改</div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      navBlock: "版本",
      navtitle: "版本更新",
      versionList: {
        renewContent: []
      },
      dialogVisible: false,
      versionInfoList: [],
      versionIndex: 0,
      oldVersion: "",
      forcedUpdate: false,
      changeType: false
    };
  },
  created() {
    this.roleType = localStorage.getItem("roleType");

    if (this.roleType != null && this.roleType.indexOf("ROLE_GUEST") > -1) {
      this.getVersionList();
    } else {
      this.$router.push("/home");
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    toNumber(a) {
      let c = a.toString().split(".");
      let num_place = ["", "0", "00", "000", "0000"],
        r = num_place.reverse();
      for (let i = 0; i < c.length; i++) {
        let len = c[i].length;
        c[i] = r[len] + c[i];
      }
      let res = c.join("");
      return res;
    },
    // 版本比较
    compareVersion(v1, v2) {
      let _this = this;
      var a = _this.toNumber(v1);
      var b = _this.toNumber(v2);
      if (a === b) {
        return true;
      } else if (a > b) {
        return false;
      } else if (a < b) {
        return true;
      }
    },
    // 修改版本提交
    editConfirm() {
      let _this = this;
      if (_this.versionList.version === "") {
        _this.dialogVisible = true;
        _this.$propMessage("當前版本不能為空!", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      let vsFlag = _this.compareVersion(
        _this.oldVersion,
        _this.versionList.version
      );
      if (!vsFlag) {
        _this.dialogVisible = true;
        _this.$propMessage("更新版本需要大於當前版本號!", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      let renewContent = this.versionList.renewContent.filter(
        val => val !== ""
      );
      let param = {
        appMarket: _this.versionList.appMarket,
        updateTime: _this.versionList.updateTime,
        updateUrl: _this.versionList.updateUrl,
        version: _this.versionList.version,
        updateStatus:
          _this.forcedUpdate === true
            ? _this.versionList.appMarket === 4
              ? 3
              : 1
            : 0,
        renewContent: renewContent
      };
      _this
        .$post("/request/version/setVersion", param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            console.log(res);
            // 修改成功
            if (res.data === true) {
              _this.$propMessage("修改成功", "success", function() {
                _this.dialogVisible = false;
                _this.changeType = false;
                _this.versionList.renewContent = renewContent;
                _this.versionInfoList[_this.versionIndex] = Object.assign(
                  {},
                  _this.versionList
                );
              });
              _this
                .$post(
                  "/request/version/getVersion",
                  {},
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  if (res.code === "00000") {
                    _this.versionInfoList = res.data;
                    this.setVersionInfo(_this.versionIndex, "loading");
                  } else {
                    _this.$propMessage(res.message, "error");
                  }
                });
            }
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    getVersionList() {
      let _this = this;
      _this
        .$post("/request/version/getVersion", {}, _this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.code === "00000") {
            _this.versionInfoList = res.data;
            this.setVersionInfo(0, "loading");
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    setVersionInfo(index, type) {
      this.versionList = Object.assign({}, this.versionInfoList[index]);
      this.versionIndex = index;
      if (!this.versionList.renewContent) {
        this.versionList.renewContent = [""];
      }
      this.forcedUpdate =
        this.versionList.updateStatus === 1 ||
        this.versionList.updateStatus === 3;
      this.oldVersion = this.versionList.version;
      if (type !== "loading") {
        this.changeType = false;
      }
    },
    editRenewContent(type, index) {
      if (type === "cut") {
        this.versionList.renewContent.splice(index, 1);
      } else {
        this.versionList.renewContent.push("");
      }
    },
    cancelConfirm() {
      this.getVersionList();
      this.changeType = false;
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>
<style lang="less" scoped>
.contentDetails {
  .version_list {
    margin-bottom: 0.3rem;
    display: flex;
    .version_btn {
      position: relative;
      font-size: 18px;
      color: #4a4a4a;
      cursor: pointer;
      &.checked {
        &:after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -6px;
          display: block;
          width: 100%;
          height: 5px;
          background-color: #6c3dea;
        }
      }
    }
    .version_btn + .version_btn {
      margin-left: 0.8rem;
    }
  }
  .update_detail_list {
    margin-bottom: 0.1rem;
  }
  .add_btn {
    margin-top: 0.1rem;
    width: 0.8rem;
    height: 0.36rem;
    line-height: 0.36rem;
    text-align: center;
    background: #f2f0f7;
    color: #938ea4;
    border-radius: 0.04rem;
    cursor: pointer;
  }
  .delete_btn {
    display: inline-block;
    margin: 0 0.1rem 0 0.24rem;
    cursor: pointer;
    line-height: 40px;
    color: #6c3dea;
  }
  .bottomBtnGroup {
    display: flex;
  }
}
</style>
<style lang="less" scoped>
.contentDetails {
  .detailsContent {
    .el-form-item__content {
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/version/editVersion.vue